import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana115Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1420_12130)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M610.503 678.698L707.103 823.598L648.453 663.748L610.503 678.698Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M573.706 616.601L610.506 678.701L648.456 663.751L623.156 598.201L573.706 616.601Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M544.958 566L573.708 616.6L623.158 598.2L605.908 544.15L544.958 566Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M523.106 520L544.956 566L605.906 544.15L588.656 497L523.106 520Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M502.404 477.451L523.104 520.001L588.654 497.001L573.704 453.301L502.404 477.451Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M485.156 438.351L502.406 477.451L573.706 453.301L561.056 413.051L485.156 438.351Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M469.053 399.249L485.153 438.349L561.053 413.049L549.553 373.949L469.053 399.249Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M454.107 363.6L469.057 399.25L549.557 373.95L538.057 336L454.107 363.6Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M440.305 326.8L454.105 363.6L538.055 336L526.555 300.35L440.305 326.8Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M427.657 291.149L440.307 326.799L526.557 300.349L516.207 264.699L427.657 291.149Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M416.157 256.649L427.657 291.149L516.207 264.699L507.007 230.199L416.157 256.649Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M501.256 207.2L507.006 230.2L416.156 256.65C413.396 248.37 415.006 234.033 416.156 227.9C419.836 209.5 442.99 203.366 454.106 202.6L501.256 207.2Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1420_12130" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1420_12130" transform="matrix(0.00157742 0 0 0.00209123 -4.07551 -2.85839)"/>
    </pattern>
    <image id="image0_1420_12130" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};